// import React, { useState } from "react";
// import axios from "axios";

// const RelationManagerRegistrationForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     address: "",
//     mobileNo: "",
//     whatsappNo: "",
//     whatsappSame: false,
//     email: "",
//     area:"",
//     username: "",
//     password: ""
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//       whatsappNo: name === "whatsappSame" && checked ? prev.mobileNo : prev.whatsappNo
//     }));
//   };

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   const submitData = { ...form };
//   if (form.whatsappSame) {
//     submitData.whatsappNo = form.mobileNo;
//   }

//   try {
//     const res = await axios.post(
//       "https://sakhisshop.com/api/rm/register",
//       submitData,
//       {
//         headers: {
//           "Content-Type": "application/json"
//         }
//       }
//     );
//     alert("✅ Relation Manager registered!");
//     setForm({
//       name: "",
//       address: "",
//       mobileNo: "",
//       whatsappNo: "",
//       whatsappSame: false,
//       email: "",
//       area: "",
//       username: "",
//       password: ""
//     });
//   } catch (err) {
//     console.error("❌ Registration failed:", err);
//     alert("Registration error. Please try again.");
//   }
// };

//   return (
//     <div className="container mt-4">
//     <h2 className="text-start mb-4">Relation Manager Registration</h2>
//       <form onSubmit={handleSubmit}>
//         <div className="mb-3"><input   className="form-control w-50" name="name" value={form.name} onChange={handleChange} placeholder="Full Name" required /></div>
//         <div className="mb-3"><input   className="form-control w-50" name="address" value={form.address} onChange={handleChange} placeholder="Address" required /></div>
//         <div className="mb-3"><input className="form-control w-50"  name="mobileNo" value={form.mobileNo} onChange={handleChange} placeholder="Mobile Number" required /></div>
//           <div className="mb-3"><input className="form-control w-50" name="area" value={form.area} onChange={handleChange} placeholder="Area " required /></div>
//         <div className="form-check mb-2">
//           <input className="form-check-input" type="checkbox" name="whatsappSame" checked={form.whatsappSame} onChange={handleChange} />
//           <label className="form-check-label">Is WhatsApp number same as Mobile Number?</label>
//         </div>

//         {!form.whatsappSame && (
//           <div className="mb-3"><input className="form-control w-50" name="whatsappNo" value={form.whatsappNo} onChange={handleChange} placeholder="WhatsApp Number" required /></div>
//         )}

//         <div className="mb-3"><input className="form-control w-50" name="email" value={form.email} onChange={handleChange} placeholder="Email" type="email" required /></div>
//         <div className="mb-3"><input className="form-control w-50" name="username" value={form.username} onChange={handleChange} placeholder="Username" required /></div>
//         <div className="mb-3"><input className="form-control w-50" name="password" value={form.password} onChange={handleChange} placeholder="Password" type="password" required /></div>

//         <button type="submit" className="btn btn-primary w-10">Register</button>
//       </form>
//     </div>
//   );
// };

// export default RelationManagerRegistrationForm;

import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RelationManagerRegistrationForm = () => {
  const [form, setForm] = useState({
    name: "",
    address: "",
    mobileNo: "",
    whatsappNo: "",
    whatsappSame: false,
    email: "",
    area: "",
    username: "",
    password: "",
  });
  const [usernameError, setUsernameError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      whatsappNo:
        name === "whatsappSame" && checked ? prev.mobileNo : prev.whatsappNo,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const submitData = { ...form };
    if (form.whatsappSame) {
      submitData.whatsappNo = form.mobileNo;
    }

    try {
      const res = await axios.post(
        "https://sakhisshop.com/api/rm/register",
        submitData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      alert("✅ Relation Manager registered!");
      setForm({
        name: "",
        address: "",
        mobileNo: "",
        whatsappNo: "",
        whatsappSame: false,
        email: "",
        area: "",
        username: "",
        password: "",
      });
    } catch (err) {
      const backendMessage =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Registration error. Please try again.";

      // Inline only for username error
      if (backendMessage.toLowerCase().includes("username")) {
        setUsernameError(backendMessage); // show under field
        return; // prevent alert/popup
      }

      // Show popup for all other errors
      toast.error(backendMessage);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="text-start mb-4">Relation Manager Registration</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            className="form-control w-50"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Full Name"
            required
          />
        </div>
        <div className="mb-3">
          <input
            className="form-control w-50"
            name="address"
            value={form.address}
            onChange={handleChange}
            placeholder="Address"
            required
          />
        </div>
        <div className="mb-3">
          <input
            className="form-control w-50"
            name="mobileNo"
            value={form.mobileNo}
            onChange={handleChange}
            placeholder="Mobile Number"
            required
          />
        </div>
        <div className="mb-3">
          <input
            className="form-control w-50"
            name="area"
            value={form.area}
            onChange={handleChange}
            placeholder="Area "
            required
          />
        </div>
        <div className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            name="whatsappSame"
            checked={form.whatsappSame}
            onChange={handleChange}
          />
          <label className="form-check-label">
            Is WhatsApp number same as Mobile Number?
          </label>
        </div>

        {!form.whatsappSame && (
          <div className="mb-3">
            <input
              className="form-control w-50"
              name="whatsappNo"
              value={form.whatsappNo}
              onChange={handleChange}
              placeholder="WhatsApp Number"
              required
            />
          </div>
        )}

        <div className="mb-3">
          <input
            className="form-control w-50"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email"
            type="email"
            required
          />
        </div>
        <div className="mb-3">
          <input
            className={`form-control w-50 ${usernameError ? "is-invalid" : ""}`}
            name="username"
            value={form.username}
            onChange={(e) => {
              handleChange(e);
              setUsernameError(""); // clear inline error while typing
            }}
            placeholder="Username"
            required
          />
          {usernameError && (
            <div className="invalid-feedback">{usernameError}</div>
          )}
        </div>
        <div className="mb-3">
          <input
            className="form-control w-50"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Password"
            type="password"
            required
          />
        </div>

        <button type="submit" className="btn btn-primary w-10">
          Register
        </button>
      </form>
    </div>
  );
};

export default RelationManagerRegistrationForm;
